export class StageConstants
{
  public static readonly XML_NAMESPACE_SVG: string =
      'http://www.w3.org/2000/svg';
  public static readonly XML_NAMESPACE_PAP: string =
      'http://www.puzzleandplay.de/';

  public static readonly COMPONENT_BOX_LARGE: string = 'BOX_LARGE';
  public static readonly COMPONENT_BOX_LARGE_2023: string = 'BOX_LARGE_2023';
  public static readonly COMPONENT_BOX_SMALL: string = 'BOX_SMALL';

  public static readonly GROUP_TAG_DESIGN_ONLY: string = 'design-only';
  public static readonly GROUP_TAG_OVERLAYS: string = 'overlays';
  public static readonly GROUP_TAG_TRANSFORM_HANDLE: string =
      'transform-handle';
  public static readonly MARKER_BORDER_SCREEN_WIDTH: number = 4;
  public static readonly TEXT_MARKER_BORDER_SCREEN_WIDTH: number = 3;
  public static readonly TEXT_MARKER_SCREEN_RADIUS: number = 4;

  public static readonly CLASS_NAME_QUALITY_INDICATION: string =
      'quality-indication';
  public static readonly CLASS_NAME_DROP_TARGET_MARKER: string =
      'drop-target-marker';
  public static readonly CLASS_NAME_EDIT_MARKER: string = 'edit-marker';
  public static readonly CLASS_NAME_EDIT_MARKER_STROKE: string =
      'edit-marker-stroke';
  public static readonly CLASS_NAME_TEXT_MARKER: string = 'text-marker';
  public static readonly CLASS_NAME_HOVER_MARKER: string = 'hover-marker';
  public static readonly CLASS_NAME_HIDE_PLACEHOLDER_THROUGH_OPACITY: string =
      'hide-placeholder-through-opacity';
  public static readonly CLASS_NAME_HIGHLIGHT_MARKER: string =
      'highlight-marker';
  public static readonly CLASS_NAME_LOADING_MARKER: string = 'loading-marker';
  public static readonly CLASS_NAME_PLACEHOLDER_HIGHLIGHTER: string =
      'placeholder-highlighter';
  public static readonly CLASS_NAME_IMAGE_OVERLAY: string =
      'image-overlay';
  public static readonly CLASS_NAME_TEXT_INPUT_CURSOR: string =
      'text-input-cursor';
  public static readonly CLASS_NAME_TEXT_FOCUS_BACKGROUND: string =
      'text-focus-background';
  public static readonly CLASS_NAME_SAFE_AREA_HINT: string = 'safe-area-hint';

  public static readonly SAFE_AREA_MARGIN_FACTOR: number = 0.005;
  public static readonly HIGHLIGHT_TIMEOUT: number = 10000; /* ms */

  public static readonly ATTRIBUTE_COMPONENT_TYPE: string =
      'pap:component-type';
  public static readonly ATTRIBUTE_BOUNDING_BOX: string = 'pap:bbox';
  public static readonly ATTRIBUTE_CONTENT_CHANGEABLE: string =
      'pap:content-changeable';
  public static readonly ATTRIBUTE_COPY_FROM: string = 'pap:copy-from';
  public static readonly ATTRIBUTE_IS_VOLATILE_IF_UNCHANGED: string =
      'pap:is-volatile-if-unchanged';
  public static readonly ATTRIBUTE_HINT_IF_UNCHANGED: string =
      'pap:hint-if-unchanged';
  public static readonly ATTRIBUTE_HREF: string = 'pap:href';
  public static readonly ATTRIBUTE_IS_UNCHANGED: string = 'pap:is-unchanged';
  public static readonly ATTRIBUTE_IS_ASSET: string = 'pap:is-asset';
  public static readonly ATTRIBUTE_TRAUDL_PIPELINE: string =
      'pap:traudl-pipeline';
  public static readonly ATTRIBUTE_PLACEHOLDER_URL: string =
      'pap:placeholder-url';
  public static readonly ATTRIBUTE_PLACEHOLDER_TEXT: string =
      'pap:placeholder-text';
  public static readonly ATTRIBUTE_QUALITY_RATING: string =
      'pap:quality-rating';
  public static readonly ATTRIBUTE_SOURCE_IMG_DIMENSIONS: string =
      'pap:img-dimensions';
  public static readonly ATTRIBUTE_ZOOM_MODE: string = 'pap:zoom-mode';
  public static readonly ATTRIBUTE_PENDING: string = 'pap:pending';
  public static readonly ATTRIBUTE_ORIGINAL_VIEWBOX: string =
      'pap:original-viewBox';

  public static readonly ATTRIBUTE_COPIED_FROM: string = 'pap:copied-from';
  public static readonly ATTRIBUTE_INITIAL_STRUCTURE_URL: string =
      'pap:initial-structure-url';

  public static readonly ATTRIBUTE_MIN_FONT_SIZE: string = 'pap:min-font-size';
  public static readonly ATTRIBUTE_FONT_SIZE_CHANGEABLE: string =
      'pap:font-size-changeable';
  public static readonly ATTRIBUTE_FONT_CHANGEABLE: string =
      'pap:font-changeable';
  public static readonly ATTRIBUTE_COLOR_CHANGEABLE: string =
      'pap:color-changeable';
  public static readonly ATTRIBUTE_ALIGNMENT_CHANGEABLE: string =
      'pap:alignment-changeable';
  public static readonly ATTRIBUTE_VERTICAL_ALIGNMENT: string =
      'pap:vertical-alignment';
  public static readonly ATTRIBUTE_TEXT_ANCHOR: string =
      'text-anchor';
  public static readonly ATTRIBUTE_TEXT_MODEL: string =
      'pap:text-model';
  public static readonly ATTRIBUTE_DEFAULT_TEXT_MODEL: string =
      'pap:default-text-model';
  public static readonly ATTRIBUTE_PART_ID: string = 'pap:part-id';

  public static readonly ATTRIBUTE_IMAGE_MODEL: string =
      'pap:image-model';

  public static readonly ATTRIBUTE_IS_PUZZLE_CONTOUR: string =
      'pap:is-puzzle-contour';

  public static readonly ZOOM_MODE_CUT: string = 'cut';
  public static readonly ZOOM_MODE_FIT: string = 'fit';
  public static readonly ZOOM_MODE_LIMIT: string = 'limit';

  public static readonly PIXEL_WHITE: string =
      './assets/img/pixel-white.gif';

  public static readonly REFERENCING_SVG_ATTRIBUTES: Array<string> =
    ['clip-path', 'mask'];

  public static readonly DESIGNABLE_PART_IDS: Array<string> =
      ['stage', 'default'];

  public static readonly BOX_TITLE_TEXT_ID: string = 'txt-main';

  public static readonly DESIGNER_ONLY_CLASSES: Array<string> = [
      StageConstants.CLASS_NAME_QUALITY_INDICATION,
      StageConstants.CLASS_NAME_DROP_TARGET_MARKER,
      StageConstants.CLASS_NAME_EDIT_MARKER,
      StageConstants.CLASS_NAME_HIGHLIGHT_MARKER,
      StageConstants.CLASS_NAME_PLACEHOLDER_HIGHLIGHTER,
      StageConstants.CLASS_NAME_LOADING_MARKER,
      StageConstants.CLASS_NAME_EDIT_MARKER_STROKE,
      StageConstants.CLASS_NAME_HOVER_MARKER,
      StageConstants.CLASS_NAME_TEXT_MARKER,
      StageConstants.CLASS_NAME_IMAGE_OVERLAY,
      StageConstants.CLASS_NAME_TEXT_INPUT_CURSOR,
      StageConstants.CLASS_NAME_TEXT_FOCUS_BACKGROUND,
      StageConstants.CLASS_NAME_SAFE_AREA_HINT,
      StageConstants.GROUP_TAG_OVERLAYS,
      StageConstants.GROUP_TAG_DESIGN_ONLY,
      StageConstants.GROUP_TAG_TRANSFORM_HANDLE,
  ];
}

export class ProgressConstants
{
  public static readonly GROUP_ADDITIONAL_PRODUCTS: string =
      'additionalProducts';
  public static readonly GROUP_COLLAGEDESIGNER: string = 'collagedesigner';
  public static readonly GROUP_FEATURES: string = 'features';
}

export class GalleryConstants
{
  // Resi muss SVGs akzeptieren (Ticket: #10696). Ein Upload von SVGs seitens
  // Kunden ist jedoch nicht erlaubt (es könnten bspw. Schriftarten verwendet
  // werden, die wir im FontStore nicht haben).
  public static readonly CONTENT_TYPE_BLACKLIST: Array<string> =
      ['image/svg', 'image/svg+xml'];
  public static readonly THUMB_HEIGHT: number = 75;
  public static readonly LOADING_ICON_URL: string =
      './assets/img/loading.gif';

  public static readonly GALLERY_IMAGE_DISPOSITION: string =
      'productdesigner-gallery';

  public static readonly MULTI_VERSION_IMAGE_RESOLUTION_MULTIPLIER: number =
      2.0;
}

export class ToolboxConstants
{
  public static readonly AFTER_TEXT_TOOLBOX_ANIMATION: number = 1100; /* ms */
}

export class GlobalConstants
{
  public static readonly MODE_DEFAULT: string = 'default';
  public static readonly MODE_GOD: string = 'god';
  public static readonly MODE_TRANSLATOR: string = 'translator';
  public static readonly HTTP_REQUEST_MAX_RETRIES: number = 2;
  public static readonly HTTP_REQUEST_DEFAULT_TIMEOUT: number = 500; // ms
  public static readonly PRINTDATA_JPEG_QUALITY: number = 95;
}
